import { ICondicaoTempo, ISeveridadeAlerta } from '../../shared/services/api/mercado';

// Cores do cabeçalho do painel inicial (saudação + letreiro de cotações +
// previsão do tempo). Escuro (fundo azul-petróleo do login) nos temas com
// menu escuro; claro no tema "Claro (menu claro)", pra combinar com a tela
// toda clara.
export interface ICoresCabecalho {
  fundo: string;
  borda: string;
  pontos: string; // grade de pontos decorativa
  texto: string;
  textoSecundario: string;
  destaque: string;
  destaqueFundo: string; // realce do "Hoje" na previsão
  chuva: string;
  painelFundo: string; // "vidro" da previsão e dos chips de cotação
  painelBorda: string;
  painelHover: string;
  subiu: string;
  caiu: string;
  avatarBorda: string;
  condicao: Record<ICondicaoTempo['icone'], string>;
  alerta: Record<ISeveridadeAlerta, string>;
  campoFundo: string;
  campoBorda: string;
  erroCampo: string;
}

export const CABECALHO_ESCURO: ICoresCabecalho = {
  fundo: `
    radial-gradient(circle at 18% 20%, rgba(32, 205, 247, 0.16) 0, transparent 45%),
    linear-gradient(135deg, #003A50 0%, #002C3D 45%, #001E27 100%)
  `,
  borda: 'transparent',
  pontos: 'rgba(255, 255, 255, 0.07)',
  texto: '#FFFFFF',
  textoSecundario: 'rgba(255, 255, 255, 0.66)',
  destaque: '#20CDF7',
  destaqueFundo: 'rgba(32, 205, 247, 0.14)',
  chuva: '#7CC4FF',
  painelFundo: 'rgba(255, 255, 255, 0.07)',
  painelBorda: 'rgba(255, 255, 255, 0.12)',
  painelHover: 'rgba(255, 255, 255, 0.11)',
  subiu: '#6EE7B7',
  caiu: '#FCA5A5',
  avatarBorda: 'rgba(32, 205, 247, 0.6)',
  condicao: {
    sol: '#FBBF24',
    nublado: '#CBD5E1',
    chuva: '#7CC4FF',
    tempestade: '#C4B5FD',
    neblina: '#CBD5E1',
    neve: '#BAE6FD',
  },
  alerta: { perigo: '#FCA5A5', atencao: '#FCD34D', positivo: '#6EE7B7' },
  campoFundo: 'rgba(255, 255, 255, 0.08)',
  campoBorda: 'rgba(255, 255, 255, 0.2)',
  erroCampo: '#FCA5A5',
};

export const CABECALHO_CLARO: ICoresCabecalho = {
  fundo: `
    radial-gradient(circle at 18% 20%, rgba(2, 132, 199, 0.10) 0, transparent 45%),
    linear-gradient(135deg, #FFFFFF 0%, #F4F9FC 55%, #E9F3FA 100%)
  `,
  borda: 'rgba(2, 132, 199, 0.14)',
  pontos: 'rgba(2, 132, 199, 0.09)',
  texto: '#0F172A',
  textoSecundario: '#526277',
  destaque: '#0284C7',
  destaqueFundo: 'rgba(2, 132, 199, 0.09)',
  chuva: '#2563EB',
  painelFundo: 'rgba(255, 255, 255, 0.78)',
  painelBorda: 'rgba(2, 132, 199, 0.16)',
  painelHover: 'rgba(255, 255, 255, 0.95)',
  subiu: '#059669',
  caiu: '#DC2626',
  avatarBorda: 'rgba(2, 132, 199, 0.45)',
  condicao: {
    sol: '#F59E0B',
    nublado: '#64748B',
    chuva: '#2563EB',
    tempestade: '#7C3AED',
    neblina: '#64748B',
    neve: '#0EA5E9',
  },
  alerta: { perigo: '#B91C1C', atencao: '#B45309', positivo: '#047857' },
  campoFundo: '#FFFFFF',
  campoBorda: 'rgba(2, 132, 199, 0.25)',
  erroCampo: '#B91C1C',
};
